import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { SelectField, Step } from '../SteppedForm';

const StepCameraother = (props) => {
  return (
    <Step
      id="cameraother"
      title="Camera Details"
      skip={(formdata) =>
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        props.getVehicle().carbuy ||
        props.getVehicle().camera
      }
      key={'cameraother-' + props.state.formdata.network}>
      <Typography variant="body1" class="formQuestion">
        If you are using your own camera, please provide the camera system details.
      </Typography>
      <Grid container>
        <Grid item xs={12}>
          <SelectField
            id="cammodel"
            label="Camera model"
            values={props.state.formdata.state ? props.stateconfig().cameras : []}
            required={props.networkconfig().camerasreq}
          />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepCameraother;
